import { Select } from '@mantine/core'
import { useMemo } from 'react'
import type { WafResource } from '@/api/waf'
import {
  type WafContext, parseWafContext, serializeWafContext,
} from './wafContext'

interface Props {
  resources: WafResource[]
  ctxRaw: string                       // valor atual do query param ?ctx
  onChange: (next: string) => void     // grava o ?ctx (vazio = visão geral)
}

const OVERVIEW = '__overview__'

export function WafContextSwitcher({ resources, ctxRaw, onChange }: Props) {
  const data = useMemo(() => ([
    { group: 'Geral', items: [{ value: OVERVIEW, label: 'Visão geral (todos os domínios)' }] },
    ...resources.map(r => ({
      group: r.resource_name || r.resource_arn,
      items: [
        { value: `resource:${r.resource_arn}`,
          label: `Todo o recurso (${r.domains.length} domínio(s))` },
        ...r.domains.map(d => ({ value: `host:${d}`, label: d })),
      ],
    })),
  ]), [resources])

  const current = ctxRaw ? serializeWafContext(parseWafContext(ctxRaw)) : OVERVIEW
  return (
    <Select
      label="Contexto"
      data={data}
      value={current || OVERVIEW}
      searchable
      allowDeselect={false}
      onChange={(v) => onChange(!v || v === OVERVIEW ? '' : v)}
      w={360}
    />
  )
}

// Resolve o WafContext completo (com hosts/nome do recurso) a partir do ?ctx cru.
export function resolveContext(ctxRaw: string, resources: WafResource[]): WafContext {
  const parsed = parseWafContext(ctxRaw)
  if (parsed.kind === 'resource') {
    const r = resources.find(x => x.resource_arn === parsed.arn)
    return r ? { kind: 'resource', arn: r.resource_arn,
                 name: r.resource_name || r.resource_arn, hosts: r.domains } : parsed
  }
  if (parsed.kind === 'host') {
    const r = resources.find(x => x.domains.includes(parsed.host))
    return { kind: 'host', host: parsed.host, resourceArn: r?.resource_arn || '' }
  }
  return parsed
}
